import { bl_del_driver_hdr_RowClass, bl_del_job_attachment_RowClass, bl_del_job_event_RowClass, bl_del_job_hdr_RowClass, bl_del_job_shipment_link_RowClass, bl_del_shipment_hdr_RowClass, bl_del_trip_hdr_RowClass, bl_del_vehicle_hdr_RowClass } from '../../../../dbschema';
import { BaseContainerModel } from '../../../base-container.model';

export class JobShipmentContainerModel extends BaseContainerModel {
  bl_del_job_hdr: bl_del_job_hdr_RowClass = new bl_del_job_hdr_RowClass();
  bl_del_job_attachments: bl_del_job_attachment_RowClass[] = [];
  bl_del_job_events: bl_del_job_event_RowClass[] = [];
  bl_del_job_shipment_links: bl_del_job_shipment_link_RowClass[] = [];
  bl_del_job_shipment_attachments: bl_del_job_attachment_RowClass[][] = [];
  bl_del_shipment_hdrs: bl_del_shipment_hdr_RowClass[] = [];
  bl_del_trip_hdr: bl_del_trip_hdr_RowClass = new bl_del_trip_hdr_RowClass();
  bl_del_driver_hdrs: bl_del_driver_hdr_RowClass[] = [];
  bl_del_vehicle_hdr: bl_del_vehicle_hdr_RowClass = new bl_del_vehicle_hdr_RowClass();
}